import { PartnerNameEnum } from 'shared/enums/partner-name-enum';

export const ROUTES = {
  home: '/',
  dynamic: {
    signIn: (partner?: PartnerNameEnum) =>
      partner ? `/sign-in/${partner}` : '/sign-in',
    updateAdminRole: (roleId = ':roleId') => `/admin-roles/update/${roleId}`,
    updateAdminUser: (userId = ':userId') => `/admin-users/update/${userId}`,
    gcashApplication: (applicationId = ':applicationId') =>
      `/${process.env.REACT_APP_PREFIX_PATH}/applications/${applicationId}`,
    gcashDocuments: (applicationId = ':applicationId') =>
      `/${process.env.REACT_APP_PREFIX_PATH}/applications/${applicationId}/documents`,
    gcashDocument: (
      applicationId = ':applicationId',
      documentId = ':documentId'
    ) =>
      `/${process.env.REACT_APP_PREFIX_PATH}/applications/${applicationId}/documents/${documentId}`,
  },
  adminUsers: '/admin-users',
  adminRoles: '/admin-roles',
  createAdminUser: '/admin-users/create',
  createAdminRole: '/admin-roles/create',
  adminLogs: '/audit-logs',
  verifyEmail: '/verify-email',
  gcashHomePage: `/${process.env.REACT_APP_PREFIX_PATH}/home`,
  gcashApplications: `/${process.env.REACT_APP_PREFIX_PATH}/applications`,
  gcashReports: `/${process.env.REACT_APP_PREFIX_PATH}/reports`,
  gcashActivities: `/${process.env.REACT_APP_PREFIX_PATH}/activities`,
  testErrorPage: '/test-error-page',
  another: '/*',
};
